import { css } from '@emotion/css';

export const titleStyles = css`
  margin-top: 12.8rem;
`;
